import React from 'react';
import { QueryCache } from 'react-query';
import { stopEventStreamUpdates } from '@services';
import { SecondarySidebarButton } from './styles';
import { endPresentation } from '@utils/browserStorage';
import { usePresentation } from '@context/presentation';

export const EndPresentationButton = ({ dispatch, slideId }) => {
    const queryCache = new QueryCache();
    const { presentationType, presentationId } = usePresentation();

    const handleClick = async () => {
        await stopEventStreamUpdates({ presentationType, slideId, presentationId });   
        
        endPresentation(dispatch);
        queryCache.clear();
    };

    return (
        <SecondarySidebarButton
            margin='10px'
            onClick={handleClick}>
                End Session
        </SecondarySidebarButton>
    );
};

export default EndPresentationButton;
